import AuthService from './../auth_components/js/AuthService';

const API_URL = (process.env.REACT_APP_API_URL || 'https://webbackend.aec.ac.in').replace(/\/+$/, '');
export const BaseURL = `${API_URL}/`;

export function PostData(type, userData) {
    let Auth = new AuthService();
    //let BaseURL = 'http://192.168.43.157/trading/';
    //let BaseURL = 'https://webbackend.aec.ac.in/';
    
    return new Promise((resolve, reject) => {
        fetch(BaseURL + type, {
            method: 'POST',
            body: JSON.stringify(userData),
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Auth.getToken()
            })
        })
            .then((response) => response.json())
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                reject(error);
            });
    });
}


export function GetData(type) {
    let Auth = new AuthService();
    //let BaseURL = 'http://192.168.43.157/trading/';
    //let BaseURL = 'https://webbackend.aec.ac.in/';

    return new Promise((resolve, reject) => {
        fetch(BaseURL + type, {
            method: 'GET',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Auth.getToken()
            })
        })
            .then((response) => response.json())
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                reject(error);
            });
    });
}


export function DeleteData(type) {
    let Auth = new AuthService();
    //let BaseURL = 'http://192.168.43.157/trading/';
    //let BaseURL = 'https://webbackend.aec.ac.in/';

    return new Promise((resolve, reject) => {
        fetch(BaseURL + type, {
            method: 'DELETE',
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Auth.getToken()
            })
        })
            .then((response) => response.json())
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                reject(error);
            });
    });
}



export function PostFormData(type, userData) {
    let Auth = new AuthService();
    //let BaseURL = 'http://192.168.43.157/trading/';
    //let BaseURL = 'https://webbackend.aec.ac.in/';

    return new Promise((resolve, reject) => {
        fetch(BaseURL + type, {
            method: 'POST',
            body: userData,
            headers: new Headers({
                'Authorization': 'Bearer ' + Auth.getToken()
            })
        })
            .then((response) => response.json())
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                reject(error);
            });
    });
}


export function PutData(type, userData) {
    let Auth = new AuthService();
    //let BaseURL = 'http://192.168.43.157/trading/';
    //let BaseURL = 'https://webbackend.aec.ac.in/';

    return new Promise((resolve, reject) => {
        fetch(BaseURL + type, {
            method: 'PUT',
            body: JSON.stringify(userData),
            headers: new Headers({
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Auth.getToken()
            })
        })
            .then((response) => response.json())
            .then((res) => {
                resolve(res);
            })
            .catch((error) => {
                reject(error);
            });
    });
}


// WEBPACK FOOTER //
// ./src/api/Service.js